/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-11-10 10:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ArrowLeftMinor, DesktopMajor } from '@shopify/polaris-icons';
import { getTemplateImage } from 'src/constants/theme-settings';
import { DEVICE, MAPPING_THEME_NAME } from 'src/constants/theme-settings.js';

type Props = {
  activeMenuItem: string,
  formValues: any
};

type ComposedProps = Props & WithI18nProps;

class PreviewTemplate extends Component<ComposedProps> {
  state = {
    device: DEVICE.DESKTOP,
    imgDesktop: null,
    imgMobile: null
  };

  handleSelectTheme = () => {
    const { onSelectTemplate, theme } = this.props;
    onSelectTemplate(theme);
  };

  handleChangeDevice = selectedDevice => {
    this.setState({
      device: selectedDevice
    });
    const parentElement = document.getElementById('parent-anchor');
    const childElement = document.getElementById('anchor');
    parentElement.scrollTop = childElement.offsetTop;
  };

  render() {
    const { i18n, theme, onBack } = this.props;
    const { device } = this.state;
    const templateImage = getTemplateImage(theme?.themeName);

    const devices = [
      {
        id: DEVICE.DESKTOP,
        content: <Icon source={DesktopMajor} color="base" />
      }
      // {
      //   id: DEVICE.MOBILE,
      //   content: <Icon source={MobileMajor} color="base" />
      // }
    ];

    return (
      <div className="BC-preview-template">
        <div className="BC-preview-template__header">
          <div className="BC-preview-template__header-left">
            <div className="btn-back" onClick={onBack}>
              <Icon source={ArrowLeftMinor} />
              <span>{MAPPING_THEME_NAME[theme?.themeName]}</span>
            </div>
          </div>

          <div className="BC-preview-template__header-mid">
            <ul className="Polaris-Tabs Polaris-Tabs--fillSpace">
              {devices.map(item => {
                return (
                  <li
                    className="Polaris-Tabs__TabContainer"
                    key={item.id}
                    onClick={() => this.handleChangeDevice(item.id)}>
                    <button
                      className={`Polaris-Tabs__Tab ${
                        device === item.id ? 'Polaris-Tabs__Tab--selected' : ''
                      }`}>
                      <span className="Polaris-Tabs__Title">{item.content}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="BC-preview-template__header-right">
            <Button primary onClick={this.handleSelectTheme}>
              {i18n.translate('AdminHTML.ThemeSetting.Common.select')}
            </Button>
          </div>
        </div>
        <div id="parent-anchor" className="BC-preview-template__body">
          <div id="anchor" style={{ display: 'none' }}></div>

          <img
            src={templateImage.desktop}
            alt="preview"
            rel="preload"
            style={{ display: device === DEVICE.DESKTOP ? 'initial' : 'none' }}
          />

          {/* <img
            src={templateImage.mobile}
            alt="preview"
            rel="preload"
            style={{ display: device === DEVICE.MOBILE ? 'initial' : 'none' }}
          /> */}
        </div>
      </div>
    );
  }
}

export default withI18n()(PreviewTemplate);
